/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getArrayDecoder,
  getArrayEncoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";
import {
  getHierarchicalBoundaryDecoder,
  getHierarchicalBoundaryEncoder,
  type HierarchicalBoundary,
  type HierarchicalBoundaryArgs,
} from ".";

/** Scope boundaries definition */
export type ScopeBoundaries = {
  /** Included resources */
  includedResources: Array<string>;
  /** Excluded resources */
  excludedResources: Array<string>;
  /** Resource patterns (regex) */
  resourcePatterns: Array<string>;
  /** Hierarchical boundaries */
  hierarchicalBoundaries: Array<HierarchicalBoundary>;
};

export type ScopeBoundariesArgs = {
  /** Included resources */
  includedResources: Array<string>;
  /** Excluded resources */
  excludedResources: Array<string>;
  /** Resource patterns (regex) */
  resourcePatterns: Array<string>;
  /** Hierarchical boundaries */
  hierarchicalBoundaries: Array<HierarchicalBoundaryArgs>;
};

export function getScopeBoundariesEncoder(): Encoder<ScopeBoundariesArgs> {
  return getStructEncoder([
    [
      "includedResources",
      getArrayEncoder(addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())),
    ],
    [
      "excludedResources",
      getArrayEncoder(addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())),
    ],
    [
      "resourcePatterns",
      getArrayEncoder(addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())),
    ],
    [
      "hierarchicalBoundaries",
      getArrayEncoder(getHierarchicalBoundaryEncoder()),
    ],
  ]);
}

export function getScopeBoundariesDecoder(): Decoder<ScopeBoundaries> {
  return getStructDecoder([
    [
      "includedResources",
      getArrayDecoder(addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())),
    ],
    [
      "excludedResources",
      getArrayDecoder(addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())),
    ],
    [
      "resourcePatterns",
      getArrayDecoder(addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())),
    ],
    [
      "hierarchicalBoundaries",
      getArrayDecoder(getHierarchicalBoundaryDecoder()),
    ],
  ]);
}

export function getScopeBoundariesCodec(): Codec<
  ScopeBoundariesArgs,
  ScopeBoundaries
> {
  return combineCodec(getScopeBoundariesEncoder(), getScopeBoundariesDecoder());
}
